module.exports = __webpack_public_path__ + "static/party1-e281542e16c032510cfddfb16c3697b6.jpg";